import styled, { keyframes, css } from "styled-components";

const dangerPulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 1px var(--danger), 0 0 18px var(--danger-glow), 0 6px 20px rgba(0,0,0,0.5); }
  50%      { box-shadow: 0 0 0 2px var(--danger), 0 0 30px var(--danger-glow), 0 6px 20px rgba(0,0,0,0.5); }
`;

const aboutToPop = keyframes`
  0%, 100% { filter: brightness(1.05) saturate(1.2); transform: translateX(0); }
  25%      { filter: brightness(1.4) saturate(1.5); transform: translateX(-2px); }
  75%      { filter: brightness(1.4) saturate(1.5); transform: translateX(2px); }
`;

export const WordBox = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: linear-gradient(180deg, rgba(22, 26, 35, 0.95), rgba(13, 15, 20, 0.95));
  backdrop-filter: blur(8px);
  border: 1px solid var(--border);
  width: max-content;
  max-width: 38vw;
  padding: 10px 18px;
  border-radius: 12px;
  text-transform: lowercase;
  color: var(--text-faint);
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1.5px;
  transition: scale 0.12s cubic-bezier(0.34, 1.56, 0.64, 1), border-color 0.18s ease, box-shadow 0.12s ease, background 0.18s ease, filter 0.1s ease;
  will-change: top, left;
  white-space: nowrap;
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);

  &.matched {
    border-color: var(--accent);
    background: linear-gradient(180deg, rgba(94, 234, 212, 0.12), rgba(13, 15, 20, 0.95));
    z-index: 4;
  }

  &.about-to-pop {
    animation: ${aboutToPop} 0.18s ease-in-out infinite;
  }

  &.kind-danger {
    border-color: var(--danger);
    background: linear-gradient(180deg, rgba(255, 93, 115, 0.18), rgba(20, 8, 12, 0.95));
    color: rgba(255, 200, 210, 0.4);
    animation: ${dangerPulse} 1.2s ease-in-out infinite;
  }

  &.kind-slow {
    border-color: #60a5fa;
    background: linear-gradient(180deg, rgba(96, 165, 250, 0.15), rgba(13, 15, 20, 0.95));
    box-shadow: 0 0 18px rgba(96, 165, 250, 0.35), 0 6px 20px rgba(0,0,0,0.5);
  }

  &.kind-freeze {
    border-color: #67e8f9;
    background: linear-gradient(180deg, rgba(103, 232, 249, 0.15), rgba(13, 15, 20, 0.95));
    box-shadow: 0 0 18px rgba(103, 232, 249, 0.35), 0 6px 20px rgba(0,0,0,0.5);
  }

  &.kind-heart {
    border-color: #f472b6;
    background: linear-gradient(180deg, rgba(244, 114, 182, 0.15), rgba(13, 15, 20, 0.95));
    box-shadow: 0 0 18px rgba(244, 114, 182, 0.4), 0 6px 20px rgba(0,0,0,0.5);
  }

  &.kind-bombclear {
    border-color: #fbbf24;
    background: linear-gradient(180deg, rgba(251, 191, 36, 0.15), rgba(13, 15, 20, 0.95));
    box-shadow: 0 0 18px rgba(251, 191, 36, 0.4), 0 6px 20px rgba(0,0,0,0.5);
  }

  .letter-box .letter {
    transition: color 0.1s linear, text-shadow 0.1s linear;
    user-select: none;
  }
`;

const badgeColors = {
  slow: "#60a5fa",
  freeze: "#67e8f9",
  heart: "#f472b6",
  bombclear: "#fbbf24",
  danger: "var(--danger)",
};

export const KindBadge = styled.div`
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'JetBrains Mono', monospace;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 2px;
  padding: 2px 8px;
  border-radius: 6px;
  background: var(--bg);
  color: ${(p) => badgeColors[p.$kind] || "var(--text-dim)"};
  border: 1px solid ${(p) => badgeColors[p.$kind] || "var(--border)"};
  box-shadow: 0 0 10px ${(p) => badgeColors[p.$kind] || "transparent"};
  ${(p) => p.$kind === "danger" && css`
    animation: ${dangerPulse} 1.2s ease-in-out infinite;
  `}
`;
